import {Injectable, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class WebApiHttp implements OnInit {


    // public globalurl: string = 'https://seedlive.pristinefulfil.com';
    public globalurl: string = 'https://eagleseeds.pristinebs.com';

    private apiURLArray = {

        login: '/api/LoginCredential/LoginAuthentication',
        forgetpassword: '/api/UserLogin/ForgotPassword',
        Logout: '/api/LoginCredential/LogoutOther',

        signalRNotification: '/Notification',

        Get_DoHeader_Location:"/api/GatepassCreate/Get_DoHeader_Location?location=",
        Get_DoLines_Location:"/api/GatepassCreate/Get_DoLines_Location?do_no=",
        Gatepass_Online_Create:"/api/GatepassCreate/Gatepass_Online_Create",
        Gatepass_Line_Create :"/api/GatepassCreate/Gatepass_Line_Create",
        Get_GatePass_ItemWise :"/api/GatepassCreate/Get_GatePass_ItemWise?gatepass_no=",
        Get_GatePass_Detail :"/api/GatepassCreate/Get_GatePass_Detail?do_no=",
        Delete_GatePass_Line :"/api/GatepassCreate/Delete_GatePass_Line?gatepass_no=",
        Get_Gatepass_Sale_Price :"/api/GatepassCreate/Get_Gatepass_Sale_Price",
        Gatepass_Delete_All_Line :"/api/GatepassCreate/Gatepass_Delete_All_Line?gatepass_no=",
        Gatepass_Download_Report :"/api/GatepassCreate/Gatepass_Download_Report?gatepass_no=",
        GetMasterBinList :"/api/Synchronize/Get_Master_BinList",
      
        getTodaysAttendence: '/api/Attendance/Get_Employee_Attendance?emp_code=',


    //    RFD
        getRFDList:'/api/RFDProcess/Get_RFD_Header_User',
        getRFDListLines:'/api/RFDProcess/Get_RFD_Line_User',
        getRFDSeason:'/api/Synchronize/Get_Master_Season',
        getRFDCrop:'/api/Synchronize/Get_Master_Crop_Nav',
        getRFDVariety:'/api/Synchronize/Get_Master_Item_Nav',
        createRFD:'/api/RFDProcess/RFD_Create',
    //Update MasterCount
        MasterCount:'/api/MasterCount/MasterCount_Create',
      
        Post_LotReport :"/api/GatepassCreate/LotReportInfo",
        Get_LotReport : "/api/GatepassCreate/GetLotInfo?filter="

    };
    public ApiURLArray: any = this.apiURLArray;

    constructor(private httpClient: HttpClient
    ) {

    }

    get getHTTPHeader(): any {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }

    ngOnInit(): void {

    }

    getHTTPHeaderAuth(token: string): any {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            })
        };
    }

    // post data to server
    async Post(path: string, jsondata: any): Promise<any> {
        try {
            path = this.globalurl + path;

            var heasd: HttpHeaders = new HttpHeaders({
                'Content-Type': 'application/json',
            })

            var headers = this.getHTTPHeader;
            return await new Promise<any>((resolve, reject) => {
                this.httpClient.post<any>(path, JSON.stringify(jsondata), headers).toPromise().then(result => resolve(result), error => reject({
                    condition: 'False',
                    message: error.message
                })).catch(err => reject({condition: 'False', message: err.message}));
            });
        } catch (e) {
            return new Promise<any>((resolve) => {
                resolve({condition: 'False', message: e.message})
            });
        }
    }

    // get data to the server
    async Get(path: string): Promise<any> {
        try {
            path = this.globalurl + path;
            var headers = this.getHTTPHeader;
            return await new Promise<any>((resolve, reject) => {
                this.httpClient.get<any>(path, headers).toPromise().then(result => resolve(result), error => reject({
                    condition: 'False',
                    message: error.message
                })).catch(err => reject({condition: 'False', message: err.message}));
            });
        } catch (e) {
            return new Promise<any>((resolve) => {
                resolve({condition: 'False', message: e.message})
            });
        }
    }

    // post data to server and get two type of response
    Post_Data_GetFile(path: string, jsondata: any) {
        path = this.globalurl + path;
        const request = new HttpRequest('POST', path, jsondata, {
            responseType: 'blob',
            reportProgress: true,
            headers: new HttpHeaders().append('Content-Type', 'application/json')
        });
        return this.httpClient.request(request);
    }

    Get_Data_With_DownloadStatus_GetFile(path: string) {
        path = this.globalurl + path;
        const request = new HttpRequest('GET', path, {
            responseType: 'blob',
            reportProgress: true,
            headers: new HttpHeaders().append('Content-Type', 'application/json')
        });
        return this.httpClient.request(request);
    }

    Post_Data_With_DownloadStatus_GetFile(path: string,jsondata : any) {
        path = this.globalurl + path;
        const request = new HttpRequest('POST', path, jsondata, {
            responseType: 'blob',
            reportProgress: true,
            headers: new HttpHeaders().append('Content-Type', 'application/json')
        });
        return this.httpClient.request(request);
    }

    blobToString(b) {
        var urldata, x;
        urldata = URL.createObjectURL(b);
        x = new XMLHttpRequest();
        x.open('GET', urldata, false); // although sync, you're not fetching over internet
        x.send();
        URL.revokeObjectURL(urldata);
        return x.responseText;
    }
}
